
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class SssTable extends Vue {
    //十三水
    table = {
        data: [],
        column: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                render: (h, params) => {
                    return h('div', [
                        h('p', bulidUid(params.row.uid)),
                        h(
                            'p',
                            {
                                style: {
                                    marginTop: '5px',
                                    color: 'blue'
                                }
                            },
                            String(params.row.uid).indexOf(String(this.listdata[0].user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'black',
                title: '玩家牌型',
                align: 'center',
                width: 220,
                render: (h, params) => {
                    let data = params.row.data
                    if (data.SPCT > 0) {
                        return h('div', [
                            h('div', {
                                style: {
                                    marginTop: '5px',
                                    position: 'relative',
                                    height: '50px'
                                },
                                domProps: {
                                    innerHTML: data.C.map((x, index) => {
                                        return "<img style='width:35px;position: absolute;top:0;left:" + index * 17 + 'px;z-index:' + index + ";' src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    } else {
                        return h('div', [
                            h('div', {
                                style: {
                                    marginTop: '5px'
                                },
                                domProps: {
                                    innerHTML: data.C.slice(0, 3).map((x, index) => {
                                        return "<img style='width:35px;'  src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('div', {
                                style: {
                                    marginTop: '5px'
                                },
                                domProps: {
                                    innerHTML: data.C.slice(3, 8).map((x, index) => {
                                        return "<img style='width:35px;'  src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('div', {
                                style: {
                                    marginTop: '5px'
                                },
                                domProps: {
                                    innerHTML: data.C.slice(8, 13).map((x, index) => {
                                        return "<img  style='width:35px;'  src=img/poker/" + x + '.png>'
                                    })
                                }
                            })
                        ])
                    }
                }
            },
            {
                key: 'black',
                title: '分数',
                align: 'center',
                render: (h, params) => {
                    let data = params.row.data
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: data.SPCT > 0 ? '' : "头道 :<span style='color:green;'>" + this.getType(data.CT[0]) + "</span><span style='margin-left:5px;color:" + this.getColor(data.Scores.head_score) + ";'>" + data.Scores.head_score + '</span>'
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: data.SPCT > 0 ? '' : "中道  :<span style='color:green;'>" + this.getType(data.CT[1]) + "</span><span style='margin-left:5px;color:" + this.getColor(data.Scores.middle_score) + ";'>" + data.Scores.middle_score + '</span>'
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: data.SPCT > 0 ? '' : "尾道  :<span style='color:green;'>" + this.getType(data.CT[2]) + "</span><span style='margin-left:5px;color:" + this.getColor(data.Scores.tail_score) + ";'>" + data.Scores.tail_score + '</span>'
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px',
                                height: '50px'
                            },
                            domProps: {
                                innerHTML: data.SPCT > 0 ? "<span style='color:green;'>" + this.getType(data.SPCT) + "</span><span style='margin-left:5px;color:" + this.getColor(data.Scores.spec_score) + ";'>" + data.Scores.spec_score + '</span>' : "特殊牌型：<span style='margin-left:5px;color:" + this.getColor(data.Scores.spec_score) + ";'>" + data.Scores.spec_score + '</span>'
                            }
                        })
                    ])
                }
            },
            {
                key: 'black',
                title: '打枪',
                align: 'center',
                render: (h, params) => {
                    let obj = params.row.data.Scores.shoots
                    let str1 = ''
                    let arr: any = []
                    for (let key in obj) {
                        let obj1 = {
                            uid: key,
                            value: obj[key]
                        }
                        arr.push(obj1)
                    }
                    return h('div', [
                        h('div', {
                            domProps: {
                                innerHTML: arr.map((v) => {
                                    return '<p>' + bulidUid(v.uid) + "<span style='margin-left:5px;color:" + this.getColor(v.value) + ";'>（" + v.value + '）</span></p>'
                                })
                            }
                        }),
                        h(
                            'p',
                            {
                                style: {
                                    color: ' green'
                                }
                            },
                            params.row.data.Scores.all_shoot > 0 ? '全垒打（' + params.row.data.Scores.all_shoot + '）' : ''
                        )
                    ])
                }
            },
            {
                title: '得分',
                align: 'center',
                render: (h, params) => {
                    return h(
                        'span',
                        {
                            style: {
                                color: params.row.data.Scores.total > 0 ? 'green' : 'red'
                            }
                        },
                        params.row.data.Scores.total
                    )
                }
            },
            {
                title: '金额',
                align: 'center',
                render: (h, params) => {
                    let num = (this as any).getMoney(params.row.data.Award)
                    return h(
                        'span',
                        {
                            style: {
                                color: num > 0 ? 'green' : 'red'
                            }
                        },
                        num
                    )
                }
            },
            {
                key: 'black',
                title: '实际金额',
                align: 'center',
                render: (h, params) => {
                    let num = (this as any).getMoney(params.row.data.RealAWard)
                    return h(
                        'span',
                        {
                            style: {
                                color: num > 0 ? 'green' : 'red'
                            }
                        },
                        num
                    )
                }
            }
        ]
    }
    //十三水牌型
    getType(num) {
        let str = ''
        switch (num) {
            case 1:
                str = '乌龙'
                break
            case 2:
                str = '对子'
                break
            case 3:
                str = '两对'
                break
            case 4:
                str = '三条'
                break
            case 5:
                str = '顺子'
                break
            case 6:
                str = '同花'
                break
            case 7:
                str = '葫芦'
                break
            case 8:
                str = '铁支'
                break
            case 9:
                str = '同花顺'
                break
            case 100:
                str = '三顺子'
                break
            case 110:
                str = '三同花'
                break
            case 120:
                str = '六对半'
                break
            case 130:
                str = '五对三条'
                break
            case 140:
                str = '四套三条'
                break
            case 150:
                str = '凑一色'
                break
            case 160:
                str = '全小(<=8)'
                break
            case 170:
                str = '全大(>=8)'
                break
            case 180:
                str = '三分天下(3个铁支)'
                break
            case 190:
                str = '三同花顺'
                break
            case 200:
                str = '十二皇族'
                break
            case 210:
                str = '十三水（一条龙）'
                break
            case 220:
                str = '同花十三水（清龙）'
                break
            default:
                break
        }
        return str
    }
    //十三水颜色
    getColor(num) {
        let color = '#333'
        if (num > 0) {
            color = 'blue'
        } else if (num < 0) {
            color = 'red'
        } else {
            color = '#333'
        }
        return color
    }

    getListDate() {
        let obj = JSON.parse(this.listdata[0].opt_detail).users
        let arr: any = []
        for (let i in obj) {
            let Object = {
                uid: i,
                data: obj[i]
            }
            arr.push(Object)
        }
        return arr
    }

    @Prop()
    listdata
}
